module.exports = __webpack_public_path__ + "static/media/ml.6a716494.svg";